export const API_BASE_URL = process.env.REACT_APP_API_URL
export const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL

// Auth
export const ApiLogin = {
	method: 'post',
	url: '/api/Auth/Login'
}
export const ApiCheckAuth = {
	method: 'post',
	url: 'api/Auth/CheckAuth'
}
export const ApiRegister = {
	method: 'post',
	url: 'api/Auth/Register'
}

// User
export const ApiUpdateUser = {
	method: 'post',
	url: '/api/User/Update'
}
export const ApiDeleteUser = {
	method: 'post',
	url: '/api/User/Delete'
}
export const ApiGetUser = {
	method: 'post',
	url: '/api/User/GetById'
}
export const ApiGetUserList = {
	method: 'post',
	url: '/api/User/GetList'
}
export const ApiCheckIsAdmin = {
	method: 'post',
	url: 'api/User/CheckIsAdmin'
}

// Tenant
export const ApiInsertTenant = {
	method: 'post',
	url: '/api/Tenant/Create'
}
export const ApiUpdateTenant = {
	method: 'post',
	url: '/api/Tenant/Update'
}
export const ApiDeleteTenant = {
	method: 'post',
	url: '/api/Tenant/Delete'
}
export const ApiGetTenant = {
	method: 'post',
	url: '/api/Tenant/GetById'
}
export const ApiGetTenantList = {
	method: 'post',
	url: '/api/Tenant/GetList'
}

// Customer
export const ApiInsertCustomer = {
	method: 'post',
	url: '/api/Customer/Create'
}
export const ApiUpdateCustomer = {
	method: 'post',
	url: '/api/Customer/Update'
}
export const ApiDeleteCustomer = {
	method: 'post',
	url: '/api/Customer/Delete'
}
export const ApiGetCustomer = {
	method: 'post',
	url: '/api/Customer/GetById'
}
export const ApiGetCustomerList = {
	method: 'post',
	url: '/api/Customer/GetList'
}


// Bank
export const ApiInsertBank = {
	method: 'post',
	url: '/api/Bank/Create'
}
export const ApiUpdateBank = {
	method: 'post',
	url: '/api/Bank/Update'
}
export const ApiDeleteBank = {
	method: 'post',
	url: '/api/Bank/Delete'
}
export const ApiGetBank = {
	method: 'post',
	url: '/api/Bank/GetById'
}
export const ApiGetBankList = {
	method: 'post',
	url: '/api/Bank/GetList'
}

// EDC
export const ApiInsertEdc = {
	method: 'post',
	url: '/api/Edc/Create'
}
export const ApiUpdateEdc = {
	method: 'post',
	url: '/api/Edc/Update'
}
export const ApiDeleteEdc = {
	method: 'post',
	url: '/api/Edc/Delete'
}
export const ApiGetEdc = {
	method: 'post',
	url: '/api/Edc/GetById'
}
export const ApiGetEdcList = {
	method: 'post',
	url: '/api/Edc/GetList'
}
export const ApiGetEdcBankList = {
	method: 'post',
	url: '/api/Edc/GetEdcBankList'
}

// Card Vendor
export const ApiInsertCardVendor = {
	method: 'post',
	url: '/api/CardVendor/Create'
}
export const ApiUpdateCardVendor = {
	method: 'post',
	url: '/api/CardVendor/Update'
}
export const ApiDeleteCardVendor = {
	method: 'post',
	url: '/api/CardVendor/Delete'
}
export const ApiGetCardVendor = {
	method: 'post',
	url: '/api/CardVendor/GetById'
}
export const ApiGetCardVendorList = {
	method: 'post',
	url: '/api/CardVendor/GetList'
}

// Customer Card
export const ApiInsertCustomerCard = {
	method: 'post',
	url: '/api/CustomerCard/Create'
}
export const ApiUpdateCustomerCard = {
	method: 'post',
	url: '/api/CustomerCard/Update'
}
export const ApiDeleteCustomerCard = {
	method: 'post',
	url: '/api/CustomerCard/Delete'
}
export const ApiGetCustomerCard = {
	method: 'post',
	url: '/api/CustomerCard/GetById'
}
export const ApiGetCustomerCardList = {
	method: 'post',
	url: '/api/CustomerCard/GetList'
}

// Transaction
export const ApiInsertTransaction = {
	method: 'post',
	url: '/api/Transaction/Create'
}
export const ApiUpdateTransaction = {
	method: 'post',
	url: '/api/Transaction/Update'
}
export const ApiDeleteTransaction = {
	method: 'post',
	url: '/api/Transaction/Delete'
}
export const ApiGetTransaction = {
	method: 'post',
	url: '/api/Transaction/GetById'
}
export const ApiGetTransactionList = {
	method: 'post',
	url: '/api/Transaction/GetList'
}
export const ApiGetTransactionCustomerCard = {
	method: 'post',
	url: '/api/Transaction/GetTransactionCustomerCard'
}
export const ApiGetTransactionReportEdc = {
	method: 'post',
	url: '/api/Transaction/GetTransactionReportEdc'
}
export const ApiGetTransactionStatistic = {
	method: 'post',
	url: '/api/Transaction/GetTransactionStatistic'
}
export const ApiGetCustomerRankStatistic = {
	method: 'post',
	url: '/api/Transaction/GetCustomerRankStatistic'
}
export const ApiGetDailyTransactionStatistic = {
	method: 'post',
	url: '/api/Transaction/GetDailyTransactionStatistic'
}
export const ApiGetCustomerPaymentList = {
	method: 'post',
	url: '/api/Transaction/GetCustomerPaymentList'
}

// Daily Transaction
export const ApiGetDailyTransaction = {
	method: 'post',
	url: '/api/DailyTransaction/GetList'
}
export const ApiGetPaymentReceived = {
	method: 'post',
	url: '/api/PaymentReceived/GetList'
}

// PaymentReceived
export const ApiUpdatePaymentReceived = {
	method: 'post',
	url: '/api/PaymentReceived/Update'
}

// Reseller
export const ApiCreateReseller = {
	method: 'post',
	url: '/api/Reseller/Create'
}
export const ApiDeleteReseller = {
	method: 'post',
	url: '/api/Reseller/Delete'
}
export const ApiGetResellerList = {
	method: 'post',
	url: '/api/Reseller/GetList'
}

// EDC Location
export const ApiUpdateEdcLocation = {
	method: 'post',
	url: '/api/EdcLocation/Update'
}
export const ApiGetEdcLocation = {
	method: 'post',
	url: '/api/EdcLocation/GetList'
}

// Beneficiary Account
export const ApiInsertBeneficiaryAccount = {
	method: 'post',
	url: '/api/BeneficiaryAccount/Create'
}
export const ApiUpdateBeneficiaryAccount = {
	method: 'post',
	url: '/api/BeneficiaryAccount/Update'
}
export const ApiDeleteBeneficiaryAccount = {
	method: 'post',
	url: '/api/BeneficiaryAccount/Delete'
}
export const ApiGetBeneficiaryAccount = {
	method: 'post',
	url: '/api/BeneficiaryAccount/GetById'
}
export const ApiGetBeneficiaryAccountList = {
	method: 'post',
	url: '/api/BeneficiaryAccount/GetList'
}

// Customer Exeption
export const ApiInsertCustomerExeption = {
	method: 'post',
	url: '/api/CustomerExeption/Create'
}
export const ApiDeleteCustomerExeption = {
	method: 'post',
	url: '/api/CustomerExeption/Delete'
}
export const ApiGetCustomerExeptionList = {
	method: 'post',
	url: '/api/CustomerExeption/GetList'
}

// Location
export const ApiInsertLocation = {
	method: 'post',
	url: '/api/Location/Insert'
}
export const ApiUpdateLocation = {
	method: 'post',
	url: '/api/Location/Update'
}
export const ApiDeleteLocation = {
	method: 'post',
	url: '/api/Location/Delete'
}
export const ApiGetLocation = {
	method: 'post',
	url: '/api/Location/GetById'
}
export const ApiGetLocationList = {
	method: 'post',
	url: '/api/Location/GetList'
}

// User Location Access
export const ApiInsertUserLocationAccess = {
	method: 'post',
	url: '/api/UserLocation/Insert'
}
export const ApiDeleteUserLocationAccess = {
	method: 'post',
	url: '/api/UserLocation/Delete'
}
export const ApiGetUserLocationByUserId = {
	method: 'post',
	url: '/api/UserLocation/GetUserLocationByUserId'
}
export const ApiGetUserLocationList = {
	method: 'post',
	url: '/api/UserLocation/GetLocationList'
}

// Common
export const ApiGetCommonByKey = {
	method: 'post',
	url: '/api/Common/GetByKey'
}

// Transfer Source
export const ApiGetTransferSourceList = {
	method: 'post',
	url: '/api/TransferSource/GetList'
}
export const ApiGetTransferSourceById = {
	method: 'post',
	url: '/api/TransferSource/GetById'
}
export const ApiInsertTransferSource = {
	method: 'post',
	url: '/api/TransferSource/Create'
}
export const ApiUpdateTransferSource = {
	method: 'post',
	url: '/api/TransferSource/Update'
}
export const ApiDeleteTransferSource = {
	method: 'post',
	url: '/api/TransferSource/Delete'
}


export const ApiProceedPayment = {
	method: 'post',
	url: '/api/Transaction/ProceedPayment'
}
export const ApiGetCustomerPaymentSummary = {
	method: 'post',
	url: '/api/Transaction/GetCustomerPaymentSummary'
}
export const ApiGetCustomerPaymentById = {
	method: 'post',
	url: '/api/Transaction/GetCustomerPaymentById'
}
export const ApiUpdateCustomerPayment = {
	method: 'post',
	url: '/api/Transaction/UpdateCustomerPayment'
}

export const ApiCreateCashIn = {
	method: 'post',
	url: '/api/CashIn/Create'
}
export const ApiGetCashInList = {
	method: 'post',
	url: '/api/CashIn/GetList'
}	
export const ApiGetCashInById = {
	method: 'post',
	url: '/api/CashIn/GetById'
}
export const ApiUpdateCashIn = {
	method: 'post',
	url: '/api/CashIn/Update'
}
export const ApiDeleteCashIn = {
	method: 'post',
	url: '/api/CashIn/Delete'
}

export const ApiCreateTransferPL = {
	method: 'post',
	url: '/api/TransferPL/Create'
}
export const ApiGetTransferPLList = {
	method: 'post',
	url: '/api/TransferPL/GetList'
}
export const ApiGetTransferPLById = {
	method: 'post',
	url: '/api/TransferPL/GetById'
}
export const ApiUpdateTransferPL = {
	method: 'post',
	url: '/api/TransferPL/Update'
}
export const ApiDeleteTransferPL = {
	method: 'post',
	url: '/api/TransferPL/Delete'
}


export const ApiGetDashboardInfo = {
	method: 'post',
	url: '/api/Dashboard/GetInfo'
}

export const ApiInsertSettlement = {
	method: 'post',
	url: '/api/Settlement/Create'
} 
export const ApiUpdateSettlement = {
	method: 'post',
	url: '/api/Settlement/Update'
} 
export const ApiDeleteSettlement = {
	method: 'post',
	url: '/api/Settlement/Delete'
} 
export const ApiGetSettlementById = {
	method: 'post',
	url: '/api/Settlement/GetById'
} 
export const ApiGetSettlementList = {
	method: 'post',
	url: '/api/Settlement/GetList'
} 
export const ApiPaySettlement = {
	method: 'post',
	url: '/api/Settlement/PaySettlement'
} 
export const ApiSettlementTransaction = {
	method: 'post',
	url: '/api/Settlement/SettlementTransaction'
} 

export const ApiGetBankBalanceList = { 
	method: 'post',
	url: '/api/BankBalance/GetList'
}
export const ApiUpdateBankBalance = { 
	method: 'post',
	url: '/api/BankBalance/Update'
}